import request from './axios';

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
//查询官网轮播列表
export function bannerList(data) {
  return request({
    url: '/website/index/bannerList',
    method: 'post',
    data
  });
}

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
//查询官网文章列表
export function articleList(data) {
  return request({
    url: '/website/index/artcleList',
    method: 'post',
    data
  });
}

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
//查询官网科室列表
export function departmentList(data) {
  return request({
    url: '/website/index/departmentList',
    method: 'post',
    data
  });
}

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
//查询官网医生列表
export function doctorList(data) {
  return request({
    url: '/website/index/doctorList',
    method: 'post',
    data
  });
}